import { z } from 'zod';

export const CookieMutationAction = z.union([
    z.literal('revalidateSession'),
    z.literal('enqueueGuestProduct'),
    z.literal('deleteFavoriteStore'),
    z.literal('setDeliveryStore'),
    z.literal('setPotionGuestId'),
    z.literal('deletePotionGuestId'),
]);

export type CookieMutationAction = z.infer<typeof CookieMutationAction>;
